import { Component, OnInit } from "@angular/core";
import { Observable, Subscription, of } from "rxjs";
import {
  AccountableFunctionDto,
  AcquisitionTypeDto,
  AddressBookDto,
  AppConfigurationDto,
  AssetLocationDto,
  BankingStatusDto,
  CabinetShelfRefDto,
  CofOStatusDto,
  CommunitiesDto,
  CurrencyDto,
  DivestmentStatusDto,
  DivisionTblDto,
  FiscalFileLocationDto,
  GeoDatumDto,
  GroupDto,
  IncidentQuantumOfImpactDto,
  IndividualAcreagesDto,
  LandParcelDto,
  LandTitleDto,
  LandTitleRegisterDto,
  LandUseStatusDto,
  LessorAreaMakerDto,
  LessorInfoDto,
  LessorRepresentativeDto,
  LessorRepTypeDto,
  LessorStakeholderDto,
  LgaDto,
  MeasureDto,
  MeasuringFactorDto,
  OwnershipTypeDto,
  PurposeDto,
  RackTrayRefDto,
  RightHeldDto,
  SecurityClassificationDto,
  StateDto,
  SubGroupDto,
  SubSubGroupDto,
  TerrainDto,
  TitleDto,
} from "@cradua/data";
import { AcquisitionFacade } from "../../state/+acquisition/acquisition.facade";
import { GatewayFacade } from "libs/gateway/src/lib/states/+gateway/gateway.facades";
import { fadeInAnimation } from 'libs/shared/src/lib/_animations/fade-in.animation';
import { AcquisitionGenericFacade } from "../../state/+acquisition-generic/acquisition-generic.facade";
import { DocumentFacade } from "../../../../../generic-document/src/lib/document-states/document.facade";
import { AcquisitionRoleHelperFunc } from '../../acquisition-role-func';
import { AcquisitionService } from "../../services/acquisition.service";
import { catchError, finalize, map } from "rxjs/operators";
import { NotificationService } from "@cradua/core";

@Component({
  selector: "cradua-acquisition-container",
  templateUrl: "./acquisition-container.component.html",
  styleUrls: ["./acquisition-container.component.scss"],
  animations: [fadeInAnimation],
})
export class AcquisitionContainerComponent implements OnInit {
  isLoadingLandTitle$: Observable<any>;
  isLoadingAcquisitionType$: Observable<any>;
  isLoadingCurrency$: Observable<any>;
  isLoadingMeasure$: Observable<any>;
  isLoadingSubSubGroup$: Observable<any>;
  isLoadingSubGroup$: Observable<any>;
  isLoadingGroup$: Observable<any>;
  isLoadingCategory$: Observable<any>;
  isLoadingAccountableFunction$: Observable<any>;
  isLoadingLandUseStatus$: Observable<any>;
  isLoadingDivestment$: Observable<any>;
  isLoadingRightHeld$: Observable<any>;
  isLoadingPurpose$: Observable<any>;
  isLoadingTerrain$: Observable<any>;
  isLoadingBankingStatus$: Observable<any>;
  isLoadingMeasuringFactor$: Observable<any>;
  isLoadingLandParcel$: Observable<any>;
  isLoadingAppConfig$: Observable<any>;
  isLoadingGeoDatum$: Observable<any>;
  isLoadingLessorRepType$: Observable<any>;
  isLoadingState$: Observable<any>;
  isLoadingLga$: Observable<any>;
  isLoadingCommunity$: Observable<any>;
  isLoadingDivision$: Observable<any>;
  isLoadingFileLocation$: Observable<any>;
  isLoadingCabinetShelfRef$: Observable<any>;
  isLoadingRackTrayRef$: Observable<any>;
  isLoadingDocumentType$: Observable<any>;
  isLoadingDocumentTypeCode$: Observable<any>;
  isLoadingSecurityClassification$: Observable<any>;
  isLoadingDocument$: Observable<any>;
  isLoadingTitle$: Observable<any>;
  isLoadingAddressBook$: Observable<any>;
  isLoadingBank$: Observable<any>;
  isLoadingOwnershipType$: Observable<any>;
  isLoadingLessorInfo$: Observable<any>;
  isLoadingLessorAreaMaker$: Observable<any>;
  isLoadingLessorRepresentative$: Observable<any>;
  isLoadingLessorStakeholder$: Observable<any>;
  isLoadingIndividualAcreages$: Observable<any>;
  isLoadingAssetLocation$: Observable<any>;
  isLoadingCofOStatus$: Observable<any>;
  completed$: Observable<boolean>;
  progress$: Observable<number>;
  error$: Observable<string>;
  isInProgress$: Observable<boolean>;
  isReady$: Observable<boolean>;
  hasFailed$: Observable<boolean>;
  hasStarted$: Observable<boolean>;

  landTitle$: Observable<LandTitleDto[]>;
  acquisitionType$: Observable<AcquisitionTypeDto[]>;
  currency$: Observable<CurrencyDto[]>;
  measure$: Observable<MeasureDto[]>;
  subSubGroup$: Observable<SubSubGroupDto[]>;
  subGroup$: Observable<SubGroupDto[]>;
  group$: Observable<GroupDto[]>;
  category$: Observable<any[]>;
  accountableFunction$: Observable<AccountableFunctionDto[]>;
  landUseStatus$: Observable<LandUseStatusDto[]>;
  divestment$: Observable<DivestmentStatusDto[]>;
  rightHeld$: Observable<RightHeldDto[]>;
  purpose$: Observable<PurposeDto[]>;
  terrain$: Observable<TerrainDto[]>;
  bankingStatus$: Observable<BankingStatusDto[]>;
  measuringFactor$: Observable<MeasuringFactorDto[]>;
  landParcel$: Observable<LandParcelDto[]>;
  appConfig$: Observable<AppConfigurationDto[]>;
  geoDatum$: Observable<GeoDatumDto[]>;
  lessorRepType$: Observable<LessorRepTypeDto[]>;
  state$: Observable<StateDto[]>;
  lga$: Observable<LgaDto[]>;
  community$: Observable<CommunitiesDto[]>;
  division$: Observable<DivisionTblDto[]>;
  fileLocation$: Observable<FiscalFileLocationDto[]>;
  cabinetShelfRef$: Observable<CabinetShelfRefDto[]>;
  rackTrayRef$: Observable<RackTrayRefDto[]>;
  documentType$: Observable<RackTrayRefDto[]>;
  documentTypeCode$: Observable<RackTrayRefDto[]>;
  securityClassification$: Observable<SecurityClassificationDto[]>;
  fetchDocument$: Observable<LandTitleRegisterDto[]>;
  title$: Observable<TitleDto[]>;
  addressBook$: Observable<AddressBookDto[]>;
  bank$: Observable<AddressBookDto[]>;
  ownershipType$: Observable<OwnershipTypeDto[]>;
  quantums$: Observable<IncidentQuantumOfImpactDto[]>;
  terrains$: Observable<TerrainDto[]>;
  uoms$: Observable<[]>;
  lessorInfo$: Observable<LessorInfoDto[]>;
  lessorAreaMaker$: Observable<LessorAreaMakerDto[]>;
  lessorRepresentative$: Observable<LessorRepresentativeDto[]>;
  lessorStakeholder$: Observable<LessorStakeholderDto[]>;
  individualAcreages$: Observable<IndividualAcreagesDto[]>;
  allAddressBook$: Observable<AddressBookDto[]>;
  assetLocation$: Observable<AssetLocationDto[]>;
  searchLandTitle$: Observable<LandTitleDto[]>;
  cofOStatus$: Observable<CofOStatusDto[]>;
  loggedInUser = JSON.parse(localStorage.getItem("LoggedInUser"));
  assignedRoles = JSON.parse(localStorage.getItem('AssignedRoles')) as any[] || [];
  activities = [];
  task = "list";
  view = 'mainSearch';
  selectedLandTitle$!: Observable<LandTitleDto[]>;
  loadingLandTitle = false;
  sub: Subscription;

  constructor(
    private landTitleFacade: AcquisitionFacade,
    private gatewayFacade: GatewayFacade,
    private documentFacade: DocumentFacade,
    private acquisitionGenericFacade: AcquisitionGenericFacade,
    private acquisitionService: AcquisitionService,
    private notification: NotificationService,
  ) {}

  ngOnInit() {
    this.activities = AcquisitionRoleHelperFunc(this.assignedRoles) || [];
    this.isLoadingAcquisitionType$ = this.gatewayFacade.isLoadingGateway(
      "AcquisitionType",
    );
    this.isLoadingCurrency$ = this.gatewayFacade.isLoadingGateway("Currency");
    this.isLoadingMeasure$ = this.gatewayFacade.isLoadingGateway("Measure");
    this.isLoadingSubSubGroup$ = this.gatewayFacade.isLoadingGateway(
      "SubSubGroup",
    );

    this.isLoadingGroup$ = this.gatewayFacade.isLoadingGateway("Group");
    this.isLoadingSubGroup$ = this.gatewayFacade.isLoadingGateway("SubGroup");
    this.isLoadingAccountableFunction$ = this.gatewayFacade.isLoadingGateway("AccountableFunction");
    this.isLoadingCategory$ = this.gatewayFacade.isLoadingGateway("Category");
    this.isLoadingLandUseStatus$ = this.gatewayFacade.isLoadingGateway("LandUseStatus");
    this.isLoadingDivestment$ = this.gatewayFacade.isLoadingGateway("DivestmentStatus");
    this.isLoadingRightHeld$ = this.gatewayFacade.isLoadingGateway("RightHeld");
    this.isLoadingPurpose$ = this.gatewayFacade.isLoadingGateway("Purpose");
    this.isLoadingTerrain$ = this.gatewayFacade.isLoadingGateway("Terrain");
    this.isLoadingBankingStatus$ = this.gatewayFacade.isLoadingGateway("BankingStatus");
    this.isLoadingMeasuringFactor$ = this.gatewayFacade.isLoadingGateway("MeasuringFactor");
    this.isLoadingLessorRepType$ = this.gatewayFacade.isLoadingGateway("LessorRepType");
    this.isLoadingCofOStatus$ = this.gatewayFacade.isLoadingGateway("CofOStatus");
    // this.isLoadingLandParcel$ = this.acquisitionGenericFacade.isLoadingAcquisitionGeneric('LandParcel');
    this.isLoadingAppConfig$ = this.gatewayFacade.isLoadingGateway("AppConfiguration");
    this.isLoadingGeoDatum$ = this.gatewayFacade.isLoadingGateway("GeoDatum");
    this.isLoadingState$ = this.gatewayFacade.isLoadingGateway("State");
    this.isLoadingLga$ = this.gatewayFacade.isLoadingGateway("Lga");
    this.isLoadingCommunity$ = this.gatewayFacade.isLoadingGateway("Communities");
    this.isLoadingDivision$ = this.gatewayFacade.isLoadingGateway("DivisionTbl");
    this.isLoadingFileLocation$ = this.gatewayFacade.isLoadingGateway("FiscalFileLocation");
    this.isLoadingRackTrayRef$ = this.gatewayFacade.isLoadingGateway("RackTrayRef");
    this.isLoadingCabinetShelfRef$ = this.gatewayFacade.isLoadingGateway("CabinetShelfRef");
    this.isLoadingDocumentType$ = this.gatewayFacade.isLoadingGateway("DocumentType");
    this.isLoadingDocumentTypeCode$ = this.gatewayFacade.isLoadingGateway("DocumentTypeCode");
    this.isLoadingBank$ = this.gatewayFacade.isLoadingGateway("Bank");
    this.isLoadingOwnershipType$ = this.gatewayFacade.isLoadingGateway("OwnershipType");

    this.ownershipType$ = this.gatewayFacade.loadGateway("OwnershipType");
    this.bank$ = this.gatewayFacade.loadGateway("Bank");
    this.completed$ = this.documentFacade.completed();
    this.progress$ = this.documentFacade.progress();
    this.error$ = this.documentFacade.error();
    this.isInProgress$ = this.documentFacade.isInProgress();
    this.isReady$ = this.documentFacade.isReady();
    this.hasFailed$ = this.documentFacade.hasFailed();
    this.hasStarted$ = this.documentFacade.started();
    this.isLoadingSecurityClassification$ = this.gatewayFacade.isLoadingGateway("SecurityClassification");
    this.isLoadingTitle$ = this.gatewayFacade.isLoadingGateway("Title");
    // this.isLoadingAddressBook$ = this.acquisitionGenericFacade.isLoadingAcquisitionGeneric('AddressBook');
    this.isLoadingAddressBook$ = this.acquisitionGenericFacade.isLoadingAcquisitionGenericWithoutId('AddressBook');
    this.isLoadingLessorInfo$ = this.acquisitionGenericFacade.isLoadingAcquisitionGeneric('LessorInfo');
    this.isLoadingLessorAreaMaker$ = this.acquisitionGenericFacade.isLoadingAcquisitionGeneric('LessorAreaMaker');
    this.isLoadingAssetLocation$ = this.acquisitionGenericFacade.isLoadingAcquisitionGeneric('AssetLocation');
    this.isLoadingLessorRepresentative$ = this.acquisitionGenericFacade.isLoadingAcquisitionGeneric('LessorRepresentative');
    this.isLoadingLessorStakeholder$ = this.acquisitionGenericFacade.isLoadingAcquisitionGeneric('LessorStakeholder');
    this.isLoadingIndividualAcreages$ = this.acquisitionGenericFacade.isLoadingAcquisitionGeneric('IndividualAcreages');
    this.isLoadingDocument$ = this.documentFacade.isLoadingDocument;
    this.quantums$ =  this.gatewayFacade.loadGateway("IncidentQuantumOfImpact");
    this.title$ = this.gatewayFacade.loadGateway("Title");
    this.securityClassification$ = this.gatewayFacade.loadGateway("SecurityClassification");
    this.documentTypeCode$ = this.gatewayFacade.loadGateway("DocumentTypeCode");
    this.documentType$ = this.gatewayFacade.loadGateway("DocumentType");
    this.cabinetShelfRef$ = this.gatewayFacade.loadGateway("CabinetShelfRef");
    this.rackTrayRef$ = this.gatewayFacade.loadGateway("RackTrayRef");
    this.fileLocation$ = this.gatewayFacade.loadGateway("FiscalFileLocation");
    this.division$ = this.gatewayFacade.loadGateway("DivisionTbl");
    this.community$ = this.gatewayFacade.loadGateway("Communities");
    this.lga$ = this.gatewayFacade.loadGateway("Lga");
    this.state$ = this.gatewayFacade.loadGateway("State");
    this.geoDatum$ = this.gatewayFacade.loadGateway("GeoDatum");
    this.appConfig$ = this.gatewayFacade.loadGateway("AppConfiguration");
    this.measuringFactor$ = this.gatewayFacade.loadGateway("MeasuringFactor");
    this.bankingStatus$ = this.gatewayFacade.loadGateway("BankingStatus");
    this.terrain$ = this.gatewayFacade.loadGateway("Terrain");
    this.purpose$ = this.gatewayFacade.loadGateway("Purpose");
    this.rightHeld$ = this.gatewayFacade.loadGateway("RightHeld");
    this.divestment$ = this.gatewayFacade.loadGateway("DivestmentStatus");
    this.landUseStatus$ = this.gatewayFacade.loadGateway("LandUseStatus");
    this.cofOStatus$ = this.gatewayFacade.loadGateway("CofOStatus");
    this.category$ = this.gatewayFacade.loadGateway("Category");
    this.accountableFunction$ = this.gatewayFacade.loadGateway("AccountableFunction");
    this.landTitle$ = this.landTitleFacade.loadRegister$;
    this.subGroup$ = this.gatewayFacade.loadGateway("SubGroup");
    this.group$ = this.gatewayFacade.loadGateway("Group");
    this.subSubGroup$ = this.gatewayFacade.loadGateway("SubSubGroup");
    this.lessorRepType$ = this.gatewayFacade.loadGateway("LessorRepType");
    this.measure$ = this.gatewayFacade.loadGateway("Measure");
    this.currency$ = this.gatewayFacade.loadGateway("Currency");
    this.acquisitionType$ = this.gatewayFacade.loadGateway("AcquisitionType");
    this.fetchDocument$ = this.documentFacade.loadDocument;
    this.assetLocation$ = this.acquisitionGenericFacade.loadGatewayById('AssetLocation');
    this.addressBook$ = this.acquisitionGenericFacade.loadGatewayWithoutId('AddressBook');
    this.lessorInfo$ = this.acquisitionGenericFacade.loadGatewayById('LessorInfo');
    this.lessorAreaMaker$ = this.acquisitionGenericFacade.loadGatewayById('LessorAreaMaker');
    this.lessorRepresentative$ = this.acquisitionGenericFacade.loadGatewayById('LessorRepresentative');
    this.lessorStakeholder$ = this.acquisitionGenericFacade.loadGatewayById('LessorStakeholder');
    this.individualAcreages$ = this.acquisitionGenericFacade.loadGatewayById('IndividualAcreages');

  }

  onSearch(value) {
    const query = {name: value};
    this.isLoadingLandTitle$ = this.landTitleFacade.isLoadingAcquisition(query);
  }

  onTask(task: string) {
    this.task = task;
    if(task === 'create') {
      this.selectedLandTitle$ = of([]);
    }
    // this.selectedLandTitle = null;
  //  this.landTitle$ = this.landTitleFacade.clearAcquisition;
   this.fetchDocument$ = this.documentFacade.loadClearDocument();
   this.landParcel$ = this.acquisitionGenericFacade.loadGatewayClear('LandParcel');
   this.landParcel$ = this.acquisitionGenericFacade.loadGatewayClear('LessorRepresentative');
   this.landParcel$ = this.acquisitionGenericFacade.loadGatewayClear('LessorInfo');
   this.landParcel$ = this.acquisitionGenericFacade.loadGatewayClear('LessorInfo');
   this.landParcel$ = this.acquisitionGenericFacade.loadGatewayClear('IndividualAcreages');
   this.landParcel$ = this.acquisitionGenericFacade.loadGatewayClear('LessorStakeholder');
   this.landParcel$ = this.acquisitionGenericFacade.loadGatewayClear('AssetLocation');
   this.landParcel$ = this.acquisitionGenericFacade.loadGatewayClear('LessorAreaMaker');

  }

  onSearchAddressBook(query) {
    this.addressBook$ = this.acquisitionGenericFacade.loadGateway('AddressBook', query);
  }

  onEmitView(value: LandTitleDto) {
    this.loadingLandTitle = true;
    if(value != null) {

      this.isLoadingDocument$ = this.documentFacade.isLoadingDocumentById(value.id);
      this.isLoadingLessorAreaMaker$ = this.acquisitionGenericFacade.isLoadingAcquisitionGenericById('LessorAreaMaker', value.id);
      this.isLoadingLessorRepresentative$ = this.acquisitionGenericFacade.isLoadingAcquisitionGenericById('LessorRepresentative', value.id);
      this.isLoadingLessorStakeholder$ = this.acquisitionGenericFacade.isLoadingAcquisitionGenericById('LessorStakeholder', value.id);
      this.isLoadingIndividualAcreages$ = this.acquisitionGenericFacade.isLoadingAcquisitionGenericById('IndividualAcreages', value.id);
      this.isLoadingLessorInfo$ = this.acquisitionGenericFacade.isLoadingAcquisitionGenericById('LessorInfo', value.id);
      this.isLoadingAssetLocation$ = this.acquisitionGenericFacade.isLoadingAcquisitionGenericById('AssetLocation', value.id);
      // this.isLoadingLandTitle$ = this.landTitleFacade.isLoadingAcquisitionById(value.id);
      this.selectedLandTitle$ = this.acquisitionService.fetchByIdAcquisition(value.id).pipe(
        finalize(() => this.loadingLandTitle = false)
      );
    }
    this.task = 'create';
  }

  // onFindAddressBookById(id: string) {
  // this.isLoadingAddressBook$ = this.acquisitionGenericFacade.isLoadingAcquisitionGenericById('AddressBook', id);
  // }


  onSaveLandTitle(value: any) {
    this.loadingLandTitle = true;
      if(value.id != null) {
        this.selectedLandTitle$ = this.acquisitionService.updateAcquisition(value).pipe(
          map(res => [res]),
          catchError(error => {
            this.notification.error(error.message);
            return of([]);
          }),
          finalize(() => {
            this.loadingLandTitle = false;
            this.notification.success("Updated Successfully");
          })
        );


      } else {
        const {id, ...newValue} = value;
        this.selectedLandTitle$ = this.acquisitionService.createAcquisition(newValue).pipe(
      map(res => [res]),
      catchError(error => {
        this.notification.error(error.message);
        return of([]);
      }),
      finalize(() => {
        this.loadingLandTitle = false;
        this.notification.success("Saved Successfully");
      })
    );
      }
  }


  uploadFile(value: any) {
    const {FilePath, ...doc} = value;
    if(typeof FilePath === 'string') {
      doc['FilePath'] = FilePath;
    }
    doc['type'] = 'landTitleRegister';
    this.documentFacade.uploadSingleDocumentWithFile(doc, FilePath);
  }


  onSaveAddressBook(value: AddressBookDto) {
   if(value.id === null) {
   value['id'] = undefined;
   }
    const newValue = [];
    newValue.push(value);
    this.acquisitionGenericFacade.add('AddressBook', newValue);
  }

  onEmitUpdateAddressLessorInfo(value: AddressBookDto) {
    const newValue = [];
    newValue.push(value);
      this.acquisitionGenericFacade.update('LessorInfo', newValue, []);
  }

  onSaveAddressBookLessor(value: LessorInfoDto[]) {
    this.acquisitionGenericFacade.add('LessorInfo', value);
  }

  resetUpload(value) {
    this.documentFacade.resetUpload();
  }

  cancelUpload(value) {
    this.documentFacade.cancelUpload();
  }

  onEmitLessorAreaMaker(value: LessorAreaMakerDto[]) {
    this.acquisitionGenericFacade.add('LessorAreaMaker', value);
  }
  onEmitLessorRepresentative(value: LessorRepresentativeDto[]) {
    this.acquisitionGenericFacade.add('LessorRepresentative', value);
  }

  onEmitLessorStakeholder(value: LessorStakeholderDto[]) {
    this.acquisitionGenericFacade.add('LessorStakeholder', value);
  }
  onEmitIndividualAcreages(value: IndividualAcreagesDto[]) {
    this.acquisitionGenericFacade.add('IndividualAcreages', value);
  }
  onEmitAssetLocation(value: AssetLocationDto[]) {
    this.acquisitionGenericFacade.add('AssetLocation', value);
  }

  onEmitClearAddressBook(value) {
    console.log(value)
    // this.acquisitionGenericFacade.loadGatewayClear('AddressBook');
  }

  onEmitLessorAreaMakerDelete(value) {
    this.acquisitionGenericFacade.remove('LessorAreaMaker', value);
  }
  onEmitLessorRepresentativeDelete(value) {
    this.acquisitionGenericFacade.remove('LessorRepresentative', value);
  }

  onEmitLessorStakeholderDelete(value) {
    this.acquisitionGenericFacade.remove('LessorStakeholder', value);
  }
  onEmitIndividualAcreagesDelete(value) {
    this.acquisitionGenericFacade.remove('IndividualAcreages', value);
  }
  onEmitAssetLocationDelete(value) {
    this.acquisitionGenericFacade.remove('AssetLocation', value);
  }
  onEmitLessorInfoDelete(value) {
    this.acquisitionGenericFacade.remove('LessorInfo', value);
  }

  onSaveManyDoc(value: LandTitleRegisterDto[]) {
   this.isLoadingDocument$ = this.documentFacade.addAcquisitionDocument(value);
  }
}
